<template>
    <aicc-page :pageId="contextPageId">
        <ur-area>
            <div class="contents">
                <div class="contents__row first">
                    <div class="contents__row__label">{{label.contactCenterName}}</div>
                    <div class="contents__row__contents">
                        <div v-show="isCCNameEdit" style="min-width:0px; display:flex; align-items:center">
                            <!--<ur-text-field ref="ccNameTextField" class="cc_name_text_field" v-model="contactCenterNmVal" :key="byteKey" @enter="onClickCCNameEdit" @blur="onContactCenterNameBlur" />-->
                            <aicc-text-field style="width:220px" ref="ccNameTextField" v-model="contactCenterNmVal" @enter="onClickCCNameEdit" @blur="onContactCenterNameBlur" :rules="rule" :counter="ccNameMaxBytes" />
                            <!--<ur-text-field ref="ccNameTextField" class="cc_name_text_field" v-model="contactCenterNmVal" :key="byteKey" @enter="onClickCCNameEdit"/>-->
                            <ur-button text="저장" solid primary small :disabled="!isCCNameValid" @click="onClickCCNameEdit" @mousedown="onMouseDown" style="margin-left:8px" />
                        </div>
                        <div v-show="!isCCNameEdit" style="min-width:0px; display:flex; align-items:center">
                            <span>{{aiccInfo.contactCenterNm}}</span>
                            <button class="cc_name_modify_button" @click="onClickCCNameEdit"/>
                        </div>
                    </div>
                </div>
                <div class="contents__row">
                    <div class="contents__row__label">{{label.contactCenterUrl}}</div>
                    <div class="contents__row__contents">{{contactCenterUrl}}</div>
                </div>
                <div class="contents__row">
                    <div class="contents__row__label">{{label.useService}}</div>
                    <div class="contents__row__contents">
                        <div class="tab_button">
                            {{serviceTab.outbountBot.label}}
                        </div>
                        <div style="height:2px; width: 104px; background:#516af4"/>
                        <div style="height:1px; width:100%; background:#8b9abc"/>
                    </div>
                </div>
                <div class="outbound_bot_info">
                    <div class="outbound_bot_info_row first">
                        <div class="outbound_bot_info_row_label">요금제</div>
                        <div class="outbound_bot_info_row_contents">{{serviceInfo.pricePlanName}}{{serviceInfo.pricePlanDetail}}</div>
                    </div>
                    <div class="outbound_bot_info_row">
                        <div class="outbound_bot_info_row_label">서비스 시작일</div>
                        <div class="outbound_bot_info_row_contents">{{serviceStartDate}}</div>
                    </div>
                    <div class="outbound_bot_info_row last">
                        <div class="outbound_bot_info_row_label">사용 전화번호 / 채널</div>
                        <div class="outbound_bot_info_row_contents">
                            <div>
                                <div style="height:40px; min-width:1248px">
                                    <div style="float:left; height:100%; padding-top:20px">{{sipNumberInfo}}</div>
                                    <div style="float:right; height:100%;"><ur-button style="height:40px" @click="onClickSRButton" primary><i class="sr_icon"/> 변경 요청하기</ur-button></div>
                                </div>
                                <ur-data-grid ref="grid" :options="options" :headers="headers" :data-source="sipNumberList"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--
            <table class="tbl">
                <colgroup>
                    <col style="width:160px">
                    <col style="width:auto">
                </colgroup>
                <tbody>
                    <tr>
                        <th>{{label.contactCenterName}}</th>
                        <td>
                            <div v-show="isCCNameEdit" style="min-width:0px">
                                <ur-text-field ref="ccNameTextField" class="cc_name_text_field" v-model="contactCenterNmVal" @enter="onClickCCNameEdit" @blur="onContactCenterNameBlur"/>
                                <ur-button text="저장" solid primary small @click="onClickCCNameEdit" @mousedown="onMouseDown" style="margin-left:8px" />
                            </div>
                            <div v-show="!isCCNameEdit" style="min-width:0px">
                                {{aiccInfo.contactCenterNm}}
                                <button class="cc_name_modify_button" @click="onClickCCNameEdit"/>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>{{label.contactCenterUrl}}</th>
                        <td>{{contactCenterUrl}}</td>
                    </tr>
                    <tr>
                        <th>{{label.useService}}</th>
                        <td class="td__tab">
                            <ur-tab-box underline :navigation="true">
                                <ur-tab-content :idx="1" label="아웃바운드 봇">
                                    <outbound-bot-tab :serviceStartDate="aiccInfo.serviceStartDate" :items="sipNumberList" @onClickSRButton="onClickSRButton"/>
                                </ur-tab-content>
                            </ur-tab-box>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div><i/> 수신 고객의 스마트폰에 원하는 이미지를 표시할 수 있는 '스마트 레터링' 서비스도 이용 가능합니다. <a class="more">자세히보기</a></div>
            <div><i/> 고객에게 070번호가 아닌 기존 사용중인 특정 번호로 발신되길 원하시면 '발신번호 변경'을 진행해주세요. <a class="more">자세히보기</a></div>-->
        </ur-area>
        <div class="more_info">
            <div>
                <div class="txt_info"><i/>수신 고객의 스마트폰에 원하는 이미지를 표시할 수 있는&nbsp<strong>'스마트 레터링'</strong>&nbsp서비스도 이용 가능합니다.&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp<span class="underline" @click="onClickServiceCenter">자세히보기</span></div>
                <div class="txt_info" style="margin-top:8px"><i/>고객에게 070번호가 아닌 기존 사용중인 특정 번호로 발신되길 원하시면&nbsp<strong>'발신번호 변경'</strong>을 진행해주세요.&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp<span class="underline" @click="onClickServiceCenter">자세히보기</span></div>
            </div>
        </div>
        <ur-snackbar ref="snackbar" :duration="3000"/>
        <service-request-new-modal ref="modal" :pageId="contextPageId"/>
    </aicc-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';
import OutboundBotTab from './components/PGE_AIM_00001_T01';
import PGE_AIM_00001_C01 from './components/PGE_AIM_00001_C01';
import PGE_AIM_00001_C02 from './components/PGE_AIM_00001_C02';
export default {
    name:'PGE_AIM_00001',
    extends:BasePage,
    components:{
        urDataGrid,
        OutboundBotTab,
        PGE_AIM_00001_C01:PGE_AIM_00001_C01,
        PGE_AIM_00001_C02:PGE_AIM_00001_C02,
    },
    data() {
        return {
            isCCNameEdit:false,
            aiccInfo:{
                contactCenterNm:'',
                contactCenterUrl:'',
                serviceStartDate:'',
            },
            contactCenterNmVal:'',
            sipNumberList:[],
            label:{
                contactCenterName:'',
                contactCenterUrl:'',
                useService:'',
            },
            serviceInfo:{
                pricePlanName:'',
                pricePlanDetail:'',
            },
            serviceTab:{
                outbountBot:{
                    index:1,
                    label:'',
                },
            },
            mouseDown:false,
            headers:[
                {text:'전화번호', value:'sipNumber', sort:true, width:152, resizableColumn: true,
                    customValue:(v,r) => {
                        return aiccUtils.phoneNumberFormat.format(v)
                    },
                },
                {text:'채널', value:'channels', sort:true, width:126, resizableColumn: true,},
                {text:'발신번호', value:'callerId', sort: aiccUtils.sortNull, width:152, resizableColumn: true,
                    customValue:(v,r) => aiccUtils.phoneNumberFormat.format(v),
                },
                //{text:'이름', value:'description', sort:true, width:587, resizableColumn: true,
                {text:'이름', value:'description', sort: aiccUtils.sortNull, resizableColumn: true,
                    component:PGE_AIM_00001_C01,
                },
                {text:'신청일', value:'useRequestDTM', sort: aiccUtils.sortNull, width:139, resizableColumn: true,
                    customValue:(v,r) => utils.toStringByFormat(utils.toDate(v), 'YYYY-MM-DD'),
                },
            ],
            options :{
                        noInfo:true,
                        height:0,
                        infinityScroll:true,
                        headerHeight:48,
                        rowHeight:49,
                        msgEmptyData:' ',
                        resizableColumn: true,
                    },
            height:0,
            byteKey:0,
            ccNameMaxBytes:20,
            rule:[
                v => (v != null && v.length > 0)  || '필수 입력 항목입니다.',
                v => aiccUtils.getStringByteSize(v) <= this.ccNameMaxBytes || '최대 '+this.ccNameMaxBytes+'byte까지 입력 가능합니다.',
            ],
        }
    },
    created(){
    },
    mounted(){
        this.init();
        this.getAICCInfo();
        this.getMySipNumberList();
        this.options.height = window.innerHeight - 651;
        window.addEventListener('resize', this.handleResize);
        this.serviceInfo.pricePlanName = '스탠다드 요금제';
        this.serviceInfo.pricePlanDetail = ' (최소 전화번호 1회선 | 4채널 선택)';
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.handleResize);
    },
    computed:{
        contactCenterUrl(){
            return aiccUtils.urlUtil.getProtocolAndDomain() + '/home/' + this.aiccInfo.contactCenterUrl;
        },
        serviceStartDate(){
            return utils.toStringByFormat(utils.toDate(this.aiccInfo.serviceStartDate), 'YYYY-MM-DD');
        },
        sipNumberInfo(){
            let numberSum = 0;
            let channelsSum = 0;
            let format = '전화번호 %(%N1)개 / 채널 %(%N2)개';
            for(let index in this.sipNumberList) {
                numberSum++;
                channelsSum += this.sipNumberList[index].channels;
            }
            return format.replace('%(%N1)', numberSum).replace('%(%N2)', channelsSum);
        },
        isCCNameValid(){
            const byte = aiccUtils.getStringByteSize(this.contactCenterNmVal);
            if(byte < 1 || byte > this.ccNameMaxBytes) {
                return false;
            } else {
                return true;
            }
        },
    },
    watch:{
        contactCenterNmVal: {
            immediate: true,
            handler(newValue, oldValue) {
                //if(newValue.length > 20) {
                    /*
                if(aiccUtils.getStringByteSize(newValue) > 20) {
                    this.contactCenterNmVal = oldValue;
                    this.onMouseDown();
                    this.byteKey++;
                    this.$nextTick(() => {
                        this.$refs['ccNameTextField'].focus();
                        this.mouseDown = false;
                    });
                }
                */
            }
        }
    },
    methods:{
        init(){
            this.byteKey = 0;
            this.label.contactCenterName = '이름';
            this.label.contactCenterUrl = '접속경로';
            this.label.useService = '사용 서비스';
            this.serviceTab.outbountBot.label = '아웃바운드봇';
        },
        getByteSize(str){
            let totalByte = 0;
            if(str) {
                for(let ii = 0 ; ii < str.length ; ii++) {
                    const currChar = str.charAt(ii);
                    const uniCurrChar = escape(currChar);
                    if(uniCurrChar.length > 4) {
                            totalByte += 2;
                    } else {
                        totalByte += 1;
                    }
                }
            }
            return totalByte;
        },
        getAICCInfo(){
            http.request(this.contextPageId, 'DTS_AIM_00001', {})
            .then(res => {
                this.aiccInfo.contactCenterNm = res.data.aiccInfo.contactCenterNm;
                this.aiccInfo.contactCenterUrl = res.data.aiccInfo.contactCenterUrl;
                this.aiccInfo.serviceStartDate = res.data.aiccInfo.serviceStartDTM;
            })
            .catch(error => {
                console.warn(error);
            })
        },
        getMySipNumberList(){
            http.request(this.contextPageId, 'DTS_AIM_00003', {
                path: {
                    'type':'listCCInUse',
                }
            })
            .then(res => {
                this.sipNumberList = [];
                for(let index in res.data.sipNumberList) {
                    this.sipNumberList.push(res.data.sipNumberList[index]);
                    this.sipNumberList[index].isEdit = false;
                }
                this.options.msgEmptyData = '현재 사용중인 번호가 없습니다.'
            })
            .catch(error => {
                console.warn(error);
            })
        },
        onClickCCNameEdit(){
            const byte = aiccUtils.getStringByteSize(this.contactCenterNmVal);
            if(this.isCCNameEdit === true) {
                if(byte > this.ccNameMaxBytes || byte < 1) {
                    return;
                }
                this.changeContactCenterName();
            } else if(this.isCCNameEdit === false){
                this.contactCenterNmVal = this.aiccInfo.contactCenterNm;
                this.isCCNameEdit = !this.isCCNameEdit;
                this.$nextTick(() => {
                    this.$refs['ccNameTextField'].focus();
                })
            }
        },
        changeContactCenterName() {
            http.request(this.contextPageId, 'DTS_AIM_00002', {
                data:{
                    aiccInfo:{
                        contactCenterNm:this.contactCenterNmVal,
                        contactCenterUrl:this.aiccInfo.contactCenterUrl,
                        serviceStartDate:this.aiccInfo.serviceStartDate,
                    },
                }
            })
            .then(res => {
                console.log(res);
                if(res.data.reply.code === '0000') {
                    this.isCCNameEdit = !this.isCCNameEdit;
                    this.aiccInfo.contactCenterNm = this.contactCenterNmVal;
                    this.$store.commit('setContactCenterName', this.aiccInfo.contactCenterNm);
                }
                this.mouseDown = false;
            })
            .catch(error => {
                console.warn(error);
                this.mouseDown = false;
            });
        },
        onClickServiceCenter(){
            window.open(this.$t('MSG_TXT_AICC_CUSTOMER_CENTER_URL'));
            //window.alert('고객지원센터로 이동 예정');
        },
        onClickSRButton(){
            this.$refs['modal'].open();
        },
        onContactCenterNameBlur(){
            if(this.mouseDown === false) {
                this.isCCNameEdit = false;  
            }
        },
        onMouseDown(){
            this.mouseDown = true;
        },
        handleResize(event) {
            this.$nextTick(() => {
                this.options.height = window.innerHeight - 651;
            });
        },
        showSnackbar(message){
            this.$nextTick(() => {
                this.$refs.snackbar.show({text: message});  
            });    
        },

    },
}
</script>
<style scoped>
    .-page-root-container {
        height: 100%;
    }
    .ur-area {
        height: 100%;
        margin-bottom: 112px;
    }
    .contents {
        font-family: 'NotoSansCJKkr';
        min-width: 1248px;
    }
    .cc_name_modify_button {
        margin-left: 8px;
        width: 16px;
        height: 16px;
        background: url('../../../../assets/images/aicc/ic_modify.png');
        vertical-align: middle;
    }
    .txt_info {
        display: flex;
        align-items: center;
        width:100%;
        height: 20px;
        font-weight: 500;
        background:unset;
        padding-left: 0;
    }
    .txt_info i {
        display: inline-block;
        background: url('../../../../assets/images/aicc/ic_notice.png');
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }
    .txt_info strong {
        font-size:14px;
        font-weight: 500;
    }
    .link {
        text-decoration: underline;
        margin-left: 16px;
        font-size: 16px;
        color: #333;
    }
    .ur-tab__content {
        padding-top: 16px;
    }
    .contents {
        width: 100%;
        height: 100%;
        padding-bottom: 189px;
        display: flex;
        flex-direction: column;
    }
    .contents__row {
        width: 100%;
        height: 32px;
        margin-top: 28px;
        padding-left: 32px;
        display: flex;
        align-items: center;
    }
    .contents__row.first{
        margin-top: 48px;
    }
    .contents__row__label {
        width:124px;
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.38;
        letter-spacing: normal;
        text-align: left;
        color: #333;
    }
    .contents__row__contents {
        flex: 1;
        object-fit: contain;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #333;
    }
    .tab_button {
        display: table-cell;
        text-align: center;
        vertical-align: middle;
        color: #516af4;
        height: 32px;
        width: 104px;
        font-weight: bold;
    }
    .tab_line {
        height: 2px;
        width: 1332px;
        border-bottom: 1px solid #8b9abc;
    }
    .outbound_bot_info {
        width: 100%;
        flex: 1;
        padding-left: 156px;
    }
    .outbound_bot_info_row {
        height: 24px;
        margin-top: 32px;
        display: -webkit-box;
        -webkit-box-align: center;
    }
    .outbound_bot_info_row.first{
        margin-top: 52px;
    }
    .outbound_bot_info_row.last{
        margin-top:12px;
        height: 40px;
        display: flex;
    }
    .outbound_bot_info_row_label {
        width: 167px;
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #333;
        flex-shrink: 0;
    }
    .outbound_bot_info_row_contents {
        flex: 1;
        object-fit: contain;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #333;
    }
    .outbound_bot_info_row.last .outbound_bot_info_row_label {
        padding-top: 20px;
    }
    .ur-button--border.ur-button--primary {
        font-weight: 500;
    }
    .more_info {
        position: absolute;
        bottom: 0px;
        display: flex;
        align-items: center;
        height: 112px;
        padding-left: 80px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #333;
    }
    .underline {
        text-decoration: underline;
        cursor: pointer;
    }
    ::v-deep .ur-text-field > .ur-text-field__input:focus {
        background-color: #FFF;
    }
    .sr_icon {
        background-image: url('../../../../assets/images/aicc/ic_request.png');
        width: 16px;
        height: 16px;
        display: inline-block;
        position: relative;
        top: 1px;
        margin-right: 4px;
    }
    ::v-deep .ur-data-grid > .ur-data-grid__table > .ur-data-grid__header > .ur-data-grid__header__wrapper > .ur-data-grid__header__wrapper__position-adjust > .ur-data-grid__header__cell.ur-data-grid__header__cell--actionable > .ur-data-grid__header__resize-anchor::before {
        display: none;
    }
</style>